import { AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, Component, ENVIRONMENT_INITIALIZER, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { IonMenu, IonicModule, MenuController } from '@ionic/angular';
import { BillsServiceService } from './services/bills-service.service';
import { HttpClientModule } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { VerticalHeaderComponent } from './components/vertical-header/vertical-header.component';
import { MenuItem } from './components/vertical-header/vertical-header';
import { ToolsService } from './services/tools.service';
import { SplashScreenService } from './services/splash-screen.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { Platform } from '@ionic/angular';
import { MultipleOptionsModalComponent } from './components/multiple-options-modal/multiple-options-modal.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    HttpClientModule,
    HasPermissionDirective,
    VerticalHeaderComponent,
    MultipleOptionsModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  router = inject(Router);
  isDense: boolean = true;
  @ViewChild(IonMenu) menu!: IonMenu;
  private lastInteractedSelect: HTMLElement | null = null;
  private readonly handleSelectInteraction = (event: Event) => {
    const select = this.findClosestSelect(event);
    if (!select || select.getAttribute('interface') !== 'popover') {
      return;
    }
    this.lastInteractedSelect = select;
  };
  private readonly handleSelectPopoverPresent = (event: Event) => {
    const popover = event.target as HTMLElement | null;
    if (!popover || !popover.classList.contains('select-popover')) {
      return;
    }

    const trigger = this.lastInteractedSelect;
    if (!trigger) {
      return;
    }

    const triggerWidth = Math.ceil(trigger.getBoundingClientRect().width);
    if (!triggerWidth) {
      return;
    }

    popover.style.setProperty('--width', `${triggerWidth}px`);
    popover.style.setProperty('--min-width', `${triggerWidth}px`);
  };

  items = [
    {
      label: 'Inicio',
      icon: 'home-outline',
      routerLink: ['/home'],
      permission: '',
    },
    {
      label: 'Aprobar Facturas',
      icon: 'receipt-outline',
      routerLink: ['/aprove-bills'],
      permission: 'invoices.approve',
    },
    {
      label: 'Clientes',
      icon: 'people-circle-outline',
      routerLink: ['/clients'],
      permission: 'clients.list',
    },
    {
      label: 'Reportes',
      icon: 'documents-outline',
      routerLink: ['/reports'],
      permission: 'reports.list',
    },
    {
      label: 'Comunicaciones',
      icon: 'megaphone-outline',
      routerLink: ['/comunications'],
      permission: 'communications.send',
    },
    {
      label: 'Concursos',
      icon: 'gift-outline',
      routerLink: ['/contests'],
      permission: '',
    },
    {
      label: 'Pedidos',
      icon: 'cart-outline',
      routerLink: ['/contests'],
      permission: '',
    },
    {
      label: 'Eventos',
      icon: 'calendar-number-outline',
      routerLink: ['/events'],
      permission: '',
    },
    {
      label: 'Misiones',
      icon: 'star-outline',
      routerLink: ['/missions'],
      permission: '',
    },
    {
      label: 'Metas',
      icon: 'golf-outline',
      routerLink: ['/goals'],
      permission: '',
    },
    {
      label: 'Paginas11',
      icon: 'document-text-outline',
      routerLink: ['/events'],
      permission: '',
    },
  ];

  menuItems: MenuItem[] = [
    {
      id: 'dashboard',
      title: '',
      // description: 'Diseño de tablero único',
      links: [
        { id: 'home', name: 'Home', icon: 'home-outline', url: '/home' },
        // { id: 'analytics', name: 'Analytics', icon: 'pie-chart-outline', url: '/aprove-bills' },
        // { id: 'finance', name: 'Finance', icon: 'cash-outline', url: '#' },
        // { id: 'crypto', name: 'Crypto', icon: 'cube-outline', url: '#' },
      ],
    },
    {
      id: 'bill',
      title: 'Facturas',
      description: 'Gestiona tus facturas',
      links: [
        {
          id: 'approved-bills',
          name: 'Aprobar',
          icon: 'checkmark-done-circle-outline',
          url: '/aprove-bills',
          permissions: ['bills:approve'],
        },
        {
          id: 'add-bills',
          name: 'Agregar',
          icon: 'duplicate-outline',
          url: '/upload-bill/select-channel',
          permissions: ['bills:create'],
        },
        {
          id: 'view-bills',
          name: 'Ver',
          icon: 'document-text-outline',
          url: '/view-bills',
          permissions: ['bills:view'],
        },
      ],
    },
    {
      id: 'admin',
      title: 'Administración',
      links: [
        {
          id: 'contests',
          name: 'Concursos',
          icon: 'gift-outline',
          url: '/contests',
          permissions: ['contest:view', 'contest:create'],
        },
        {
          id: 'clients',
          name: 'Clientes',
          icon: 'people-circle-outline',
          url: '/clients',
          permissions: ['clients:view'],
        },
        {
          id: 'comunications',
          name: 'Comunicaciones',
          icon: 'chatbubbles-outline',
          url: '/comunications',
          permissions: ['communications:send'],
        },
        // { id: 'comunications', name: 'Comunicaciones', icon: 'chatbubbles-outline', url: '/send-communication', permissions: ['communications:send'] },
        // { id: 'repetitive-comunications', name: 'Comunicaciones repetitivas', icon: 'repeat-outline', url: '/repetitive-communications', permissions: ['communications:send'] },
        {
          id: 'orders',
          name: 'Pedidos',
          icon: 'cart-outline',
          url: '/orders',
          permissions: ['orders:view'],
        },
        // { id: 'generate-order', name: 'Generar orden', icon: 'bag-add-outline', url: '/generate-order' },
        {
          id: 'reports',
          name: 'Reportes',
          icon: 'bar-chart-outline',
          url: '',
          subMenu: [],
          permissions: ['reports:view'],
        },
        {
          id: 'promotions',
          name: 'Promociones',
          icon: 'diamond-outline',
          url: '/promotions',
          permissions: ['promotions:view'],
        },
        {
          id: 'products',
          name: 'Productos',
          icon: 'cube-outline',
          url: '/products',
          permissions: ['products:view'],
        },
        {
          id: 'events',
          name: 'Eventos',
          icon: 'calendar-number-outline',
          url: '/events',
          permissions: ['events:view'],
        },
        {
          id: 'pages',
          name: 'Paginas',
          icon: 'globe-outline',
          url: '/dasboard-pages-builder',
          permissions: ['pages:view'],
        },
        {
          id: 'missions',
          name: 'Misiones',
          icon: 'star-outline',
          url: '/missions',
          permissions: ['missions:view'],
        },
        {
          id: 'mission-review',
          name: 'Aprobar Misiones',
          icon: 'checkmark-done-circle-outline',
          url: '/mission-review',
          permissions: ['mission-review:view'],
        },
        {
          id: 'goals',
          name: 'Metas',
          icon: 'golf-outline',
          url: '/goals',
          permissions: ['goals:view'],
        },
        {
          id: 'pqrs',
          name: 'PQRS',
          icon: 'call-outline',
          url: '/pqrs',
          permissions: ['tickets:view'],
        },
      ],
    },
    {
      id: 'config',
      title: 'Configuración',
      links: [
        {
          id: 'preregister',
          name: 'Preregistro',
          icon: 'person-add-outline',
          url: '/preregister',
          permissions: ['preregister:view'],
        },
        {
          id: 'groups',
          name: 'Roles de cliente',
          icon: 'people-circle-outline',
          url: '/groups',
          permissions: ['groups:view'],
        },
        {
          id: 'platform-config',
          name: 'Configuración plataforma',
          icon: 'build-outline',
          url: '/platform-configuration',
          permissions: ['admin:view'],
        },
      ],
    },
    {
      id: 'inventory',
      title: 'Inventario',
      description: 'Gestiona equipos y espacios',
      links: [
        { id: 'inventory', name: 'Inventario', icon: 'cube-outline', url: '/inventory', permissions: ['inventory:view'] },
        { id: 'mobility', name: 'Movilidad', icon: 'bicycle-outline', url: '/mobility', permissions: ['inventory:view'] },
        { id: 'coworking', name: 'Coworking', icon: 'tv-outline', url: '/coworking', permissions: ['inventory:view'] },
      ],
    },
  ];

  showMenu: boolean = false;

  @Input() autoMode: boolean = true;
  mode!: 'determinate' | 'indeterminate';
  progress: number = 0;
  show: boolean = true;

  constructor(
    private toolService: ToolsService,
    private menuCtrl: MenuController,
    private splashScreenService: SplashScreenService,
    private platform: Platform,
  ) {
    // console.log('AppComponent', this.items);
    this.toolService.isDense$.subscribe((isDense) => {
      this.isDense = isDense;
    });

    toolService.isShowMenu$.subscribe((show) => {
      this.showMenu = show;
    });

    this.initializeApp();
  }

  openFirstMenu() {
    this.menuCtrl.open('first');
  }

  closeFirstMenu() {
    this.menuCtrl.open('first');
    this.toolService.setOpenMenu(true);
  }

  ngAfterViewInit(): void {
    if (this.menu) {
      this.menu.ionDidOpen.subscribe(() => {
        this.toolService.setMenuFixed(false);
      });
    }

    document.addEventListener('pointerdown', this.handleSelectInteraction, true);
    document.addEventListener('focusin', this.handleSelectInteraction, true);
    document.addEventListener(
      'ionPopoverWillPresent',
      this.handleSelectPopoverPresent,
      true
    );
  }

  ngOnDestroy(): void {
    document.removeEventListener(
      'pointerdown',
      this.handleSelectInteraction,
      true
    );
    document.removeEventListener('focusin', this.handleSelectInteraction, true);
    document.removeEventListener(
      'ionPopoverWillPresent',
      this.handleSelectPopoverPresent,
      true
    );
  }

  goTo(route: any) {
    this.router.navigate(route.routerLink);
  }

  test(event: boolean) {
    this.toolService.setMenuFixed(false);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Deshabilitar el modo oscuro aquí
      document.body.classList.remove('dark'); // Asegúrate de que la clase 'dark' no esté presente
    });
  }

  private findClosestSelect(event: Event): HTMLElement | null {
    const path = event.composedPath();
    for (const element of path) {
      if (element instanceof HTMLElement && element.tagName === 'ION-SELECT') {
        return element;
      }
    }
    return null;
  }
}
